import React from 'react';
import StoriesPlayer, {
    StoriesPlayerProps,
} from '../../molecules/StoriesPlayer';

export interface StoriesSectionProps extends StoriesPlayerProps {}

const StoriesSection = ({
    rootId,
    widgetId,
    widgetContainer,
}: StoriesSectionProps) => {
    return (
        <section className="my-[calc(var(--soluto-spacing-mega)-15px)] container">
            <StoriesPlayer
                rootId={rootId}
                widgetId={widgetId}
                widgetContainer={widgetContainer}
            />
        </section>
    );
};
export default StoriesSection;
